import { employees, getEmployee } from "../../models/employees";
import "./employeeSelect.css";

export default function EmployeeSelect({
  selectedEmployee,
  onSelectedEmployee,
  hiddenEmployeeIds,
}) {
  return (
    <div className="employeeSelectWrapper">
      <label className="employeeSelectLabel" htmlFor="employeeSelect">
        Vyberte barbera
      </label>
      <select
        id="employeeSelect"
        className="employeeSelect"
        value={selectedEmployee.id}
        onChange={(e) =>
          onSelectedEmployee(getEmployee(parseInt(e.target.value)))
        }
      >
        {employees.map((employee) => {
          if (hiddenEmployeeIds && hiddenEmployeeIds.includes(employee.id)) {
            return null;
          }
          return (
            <option key={employee.id} value={employee.id}>
              {employee.name} - {employee.level.toUpperCase()}
            </option>
          );
        })}
      </select>
    </div>
  );
}
